import { render, staticRenderFns } from "./VacationRejectedWidget.vue?vue&type=template&id=0293e4e4&scoped=true&"
import script from "./VacationRejectedWidget.vue?vue&type=script&lang=js&"
export * from "./VacationRejectedWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0293e4e4",
  null
  
)

export default component.exports